import { SortValues } from '@omniafishing/core';
import React from 'react';
import { useFrontload } from 'react-frontload';
import { useAfterMountedEffect } from '../../hooks/use_after_mounted_effect';
import { useQueryString } from '../../hooks/use_query_string';
import { apiV1, RECOMMENDATIONS_PAGE_SIZE_DEFAULT } from '../../lib/api';
import { OmniaQueryParams } from '../../lib/query_string';
import Loading from '../loading/loading';
import { TagProductsGrid } from './tag_products_grid';

interface OwnProps {
  defaultSortValue: SortValues;
  perPage?: number;
  productsPerRequest?: number;
  tag: string;
}

export const TagProductsGridContainer = (props: OwnProps) => {
  const { tag, defaultSortValue, perPage } = props;

  const { getCurrentQuery } = useQueryString();
  const currentQuery = getCurrentQuery<{
    [OmniaQueryParams.pg]: string;
    [OmniaQueryParams.subcategories]: string[];
    [OmniaQueryParams.sort]: SortValues;
  }>();

  const { pg, sort, subcategories } = currentQuery;

  const tagProductsFetchOptions = {
    include_out_of_stock: false,
    page: pg != null ? Number(pg) : 1,
    per_page: perPage || RECOMMENDATIONS_PAGE_SIZE_DEFAULT,
    subcategories: subcategories || [],
    sort: sort || defaultSortValue,
  };

  const { frontloadMeta, data, setData } = useFrontload(
    `TagProductsGridContainer_${tag}`,
    async () => {
      const result = await apiV1.tagProductGroupsFetch(tag, tagProductsFetchOptions);
      return {
        product_groups: result.data.data,
        metadata: result.data.metadata,
      };
    }
  );

  useAfterMountedEffect(() => {
    apiV1.tagProductGroupsFetch(tag, tagProductsFetchOptions).then((res) => {
      setData(() => ({
        product_groups: res.data.data,
        metadata: res.data.metadata,
        page: res.data.metadata.page,
      }));
    });
  }, [pg, subcategories?.join(','), sort]);

  if (frontloadMeta.pending) {
    return <Loading text="Loading" />;
  }

  return (
    <TagProductsGrid
      defaultSortValue={defaultSortValue}
      productGroups={data?.product_groups || []}
      totalProductsCount={data?.metadata.total_results || 0}
      facetSubcategories={data?.metadata.facets.subcategories || {}}
      tag={tag}
      page={data?.metadata.page || 1}
      perPage={tagProductsFetchOptions.per_page}
    />
  );
};
